<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header="Nieuw bedrijf toevoegen">
            <b-form @submit.prevent="sendForm">
              <b-row>
                <b-col cols="12">
                  <h5>Basisgegevens</h5>
                  <hr />
                </b-col>
                <b-col cols="12" md="4">
                  <b-form-group label="Naam">
                    <b-form-input type="text" required v-model="Company.name"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" md="2">
                  <b-form-group label="Relatienummer">
                    <b-form-input type="text" required v-model="Company.relation_number" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="2">
                  <b-form-group label="Mapnummer">
                    <b-form-input type="text" required v-model="Company.map_number" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" md="2">
                  <b-form-group label="Prijs per tik (in €)">
                    <b-form-input type="number" step="0.01" min="0.00" required v-model="Company.pricing" autocomplete="off"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="mt-4">
                <b-col cols="12">
                  <h5>Contactgegevens</h5>
                  <hr />
                </b-col>
                <b-col cols="12" md="3">
                  <b-form-group label="E-mail">
                    <b-form-input type="text" required v-model="Company.email"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="3">
                  <b-form-group label="Telefoonnummer">
                    <b-form-input type="text" v-model="Company.phone"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
             
              <b-row class="mt-4">
                <b-col cols="12">
                  <h5>Adresgegevens</h5>
                  <hr />
                </b-col>
                <b-col cols="12" md="4">
                  <b-form-group label="Straat + huisnummer">
                    <b-form-input type="text" v-model="Company.street"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" md="2">
                  <b-form-group label="Postcode">
                    <b-form-input type="text" v-model="Company.postal_code"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="2">
                  <b-form-group label="Stad">
                    <b-form-input type="text" v-model="Company.city"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="12">
                  <h5>Authorisatiecodes</h5>
                  <hr />
                </b-col>
                <b-col cols="12" md="4">
                  <b-form-group label="CheckSociaal">
                    <b-form-input type="text" v-model="Sites.check_sociaal.auth"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" md="4">
                  <b-form-group label="VerhuurSignaal">
                    <b-form-input type="text" v-model="Sites.verhuur_signaal.auth"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <hr />
                  <b-button type="submit" variant="success" class="pull-right" :disabled="loading">
                    <b-spinner v-show="loading" small type="grow" />
                    Toevoegen
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { getData, storeData, updateData } from '../../api';

export default {
  name: 'company-new',
  data() {
    return {
      loading: false,
      Company: {
        name: undefined,
        relation_number: undefined,
        map_number: undefined,
        pricing: undefined,
        email: undefined,
        phone: undefined,
        street: undefined,
        postal_code: undefined,
        city: undefined,
      },
      Sites: {
        check_sociaal: {
          id: 2,
          auth: '',
        },
        verhuur_signaal: {
          id: 1,
          auth: '',
        }
      },
    };
  },
  methods: {
    sendForm() {
      this.loading = true;

      const company = this.Company;
      const sites = this.Sites;

      storeData('companies', company)
        .then(async (response) => {
          const { data: { data } } = response;

          console.group('SendCompanyForm');
          console.log('Company: ', data);
          console.log('Sites: ', sites);
          console.groupEnd();

          if (sites) {
            Object.keys(sites).forEach(async (item) => {
              await this.updateCompanySite(data.id, sites[item]);
            });
          }

          this.loading = false;
          this.$router.push({
            name: 'companies.view',
            params: { id: data.id },
          });
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    async updateCompanySite(company, site) {
      console.group('UpdateCompanySites');
      console.log('Company: ', company);
      console.log('Site: ', site);
      console.groupEnd();

      const { id, auth } = site;
      return await storeData(`companies/${company}/sites/${id}`, {
        auth
      }).catch(error => {
          console.log('Error: ', error);
          this.loading = false;
        });
    },
  },
  beforeMount() {
    this.getCustomersData();
  },
};

</script>
